import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./DeductionsPage.css"; // Import shared CSS

const EditDeductionsPage = ({ selectedBusiness }) => { 
    const navigate = useNavigate();
    const location = useLocation();

    const businessId = selectedBusiness?.id;
    const employeeId = location.state?.employeeId;

    const [deductions, setDeductions] = useState({
        
        donation: "",
        garnishment: "",
    });

    const [employeeName, setEmployeeName] = useState("");
    const [isNewRecord, setIsNewRecord] = useState(true);

    useEffect(() => {
    if (!businessId || !employeeId) return;

    const fetchDeductions = async () => {
        try {
            const { data } = await api.get(
                `/businesses/${businessId}/employees/${employeeId}/deductions`
            );

            if (data) {
                setDeductions({
                    donation: data.donation ?? "",
                    garnishment: data.garnishment ?? "",
                });

                setIsNewRecord(
                    !Object.values(data).some(
                        (value) => value !== null
                    )
                );

                setEmployeeName(
                    `${data.first_name} ${data.last_name}`
                );
            }
        } catch (error) {
            console.error(
                "Error fetching deductions:",
                error
            );
            alert("Failed to load preset deductions.");
        }
    };

    fetchDeductions();
}, [businessId, employeeId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const sanitizedDeductions = {
                
                donation: deductions.donation || "",
                garnishment: deductions.garnishment || "",
            };

            if (isNewRecord) {
                await api.post(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
                    business_id: businessId,
                    ...sanitizedDeductions,
                });
                alert("Preset deductions added successfully!");
            } else {
                await api.put(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
                    business_id: businessId,
                    ...sanitizedDeductions,
                });
                alert("Preset deductions updated successfully!");
            }
            navigate(`/dashboard/business/employees`);
        } catch (error) {
            console.error("Error saving deductions:", error);
            alert("Failed to save preset deductions.");
        }
    };

    return (
        <div className="deductions-container">
            <h2 className="page-title-deduct">Preset Deductions for {employeeName}</h2>
            <form className="deductions-form" onSubmit={handleSubmit}>
                {Object.keys(deductions).map((key) => (
                    <div key={key}>
                        <label>
                            {key.replace("_", " ").toUpperCase()}:
                            <input
                                type="number"
                                value={deductions[key]}
                                onChange={(e) =>
                                    setDeductions({
                                        ...deductions,
                                        [key]: e.target.value === "" ? "" : parseFloat(e.target.value),
                                    })
                                }
                                placeholder={`Enter ${key.replace("_", " ")}`}
                            />
                        </label>
                    </div>
                ))}
                <div className="button-group">
                    <button className="save-button" type="submit">
                        Save Deductions
                    </button>
                    <button
                        className="cancel-button"
                        type="button"
                        onClick={() => navigate(`/dashboard/business/employees`)}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditDeductionsPage;




// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import api from "../services/api";

// const EditDeductionsPage = () => {
//     const {id: businessId, employeeId } = useParams();
//     const navigate = useNavigate();

//     // State for deductions
//     const [deductions, setDeductions] = useState({
//         contrib_401k: "",
//         healthcare: "",
//         dental: "",
//         vision: "",
//         donation: "",
//     });

//     // State for employee name and record type
//     const [employeeName, setEmployeeName] = useState("");
//     const [isNewRecord, setIsNewRecord] = useState(true);

//     // Fetch employee details and preset deductions
//     useEffect(() => {
//         const fetchDeductions = async () => {
//             try {
//                 const { data } = await api.get(
//                     `/businesses/${businessId}/employees/${employeeId}/deductions`
//                 );

//                 // Populate deductions and determine if it's a new record
//                 if (data) {
//                     setDeductions({
//                         contrib_401k: data.contrib_401k ?? "",
//                         healthcare: data.healthcare ?? "",
//                         dental: data.dental ?? "",
//                         vision: data.vision ?? "",
//                         donation: data.donation ?? "",
//                     });
//                     setIsNewRecord(!Object.values(data).some((value) => value !== null));
//                     setEmployeeName(`${data.first_name} ${data.last_name}`);
//                 }
//             } catch (error) {
//                 console.error("Error fetching deductions:", error);
//                 alert("Failed to load preset deductions.");
//             }
//         };

//         fetchDeductions();
//     }, [businessId, employeeId]);

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             // Prepare sanitized deductions
//             const sanitizedDeductions = {
//                 contrib_401k: deductions.contrib_401k || 0,
//                 healthcare: deductions.healthcare || 0,
//                 dental: deductions.dental || 0,
//                 vision: deductions.vision || 0,
//                 donation: deductions.donation || 0,
//             };

//             if (isNewRecord) {
//                 // Create a new record
//                 await api.post(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
//                     business_id: businessId,
//                     ...sanitizedDeductions,
//                 });
//                 alert("Preset deductions added successfully!");
//             } else {
//                 // Update the existing record
//                 await api.put(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
//                     business_id: businessId,
//                     ...sanitizedDeductions,
//                 });
//                 alert("Preset deductions updated successfully!");
//             }
//             navigate(`/dashboard/business/${businessId}/employees`);
//         } catch (error) {
//             console.error("Error saving deductions:", error);
//             alert("Failed to save preset deductions.");
//         }
//     };

//     return (
//         <div>
//             <h2>Edit Preset Deductions for {employeeName}</h2>
//             <form onSubmit={handleSubmit}>
//                 {Object.keys(deductions).map((key) => (
//                     <div key={key}>
//                         <label>
//                             {key.replace("_", " ").toUpperCase()}:
//                             <input
//                                 type="number"
//                                 value={deductions[key]}
//                                 onChange={(e) =>
//                                     setDeductions({
//                                         ...deductions,
//                                         [key]: e.target.value === "" ? "" : parseFloat(e.target.value) || 0,
//                                     })
//                                 }
//                                 placeholder={`Enter ${key.replace("_", " ")}`}
//                             />
//                         </label>
//                     </div>
//                 ))}
//                 <div>
//                     <button type="submit">Save Deductions</button>
//                     <button type="button" onClick={() => navigate(`/dashboard/business/${businessId}`)}>
//                         Cancel
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default EditDeductionsPage;
